import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { EyeIcon,Eye,Layers} from "lucide-react";
import { openGlobalPopup} from '../../redux/action';

function CategoryCard({ cat, categories, onEdit, onDelete, onOpenAddons }) {

  return (
    <div className="category-card">
      <div>
      <div className="card-header input-wrapper">
        <input className="category-name" value={cat.categoryName} onClick={() => onEdit(cat)} readOnly />
        <span class="edit-icon edit-icon-categories">✎</span>
      </div>
      </div>

      <div className="card-actions">
         <Link
          className="view-link app-back-btn"
          to={`/menu-categories/${cat.categoryId}/foods`}
          state={{ category: cat, allCategories: categories }}
        >
          <Eye size={16} color="var(--ui-warning-text)" className="sidebar-icon" />
          View & Add Items ({Number(cat.foodItemCount) || 0})
        </Link>
        <div className="category-secondary-actions">
          <button
            className="delete-cat"
            onClick={() => onDelete(cat.categoryId)}
          >
            ✖ Delete
          </button>

          <button
          type="button"
          className="addon-view-items-btn"
          onClick={() => onOpenAddons(cat)}
          >
       <Layers size={15} color="#0284c7" />
       <span>Add-ons</span>
      </button>
        </div>
      </div>
    </div>
  );
}

export default CategoryCard;
